Ext.define('SA.VectorMapConstants', {
    singleton: true,

    getAttributionHtml() {
        return [
            '<a href="https://openmaptiles.org/" target="_blank">© OpenMapTiles</a>',
            '<a href="https://www.openstreetmap.org/copyright" target="_blank">© OpenStreetMap</a>'
        ].join(' ');
    },

    getAttributionText() {
        return '© OpenMapTiles © OpenStreetMap';
    },

    getExportInsetMapExtentScale() {
        return 5;
    },

    getInsetMapStyle() {
        return '/static/theme/maplibre-gl/sa.minimap.json';
    },

    getInsetMapZoomOffset() {
        return -5;
    },

    getThematicMapStyle() {
        return '/static/theme/maplibre-gl/sa.json';
    },

    getThematicMapStyleBaseUrls() {
        return {styleJsonFolder: `${location.protocol}//${location.host}/static/theme/maplibre-gl`};
    },

    getThematicMapZoomRange() {
        return new SA.VectorMapZoomRange(3, 16);
    }
});